import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import Sidebar from '../components/Sidebar';
import FeatureCard from '../components/FeatureCard';
import UpcomingPostsCalendar from '../components/calendar/UpcomingPostsCalendar';
import {
  WritingModelVisual,
  StyleGeneratorVisual,
  VideoEditingVisual,
  MultiSourceVisual,
  PerformanceVisual,
  LayerEditingVisual
} from '../components/visuals';

function HomePage() {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const features = [
    {
      id: 'automation',
      subTitle: 'Auto Operation',
      title: 'Automation',
      description: 'Set up triggers, AI strategies, and let content auto-generate and publish.',
      visual: <LayerEditingVisual />,
      path: '/automation',
      badge: 'PRO'
    },
    {
      id: 'publish-center',
      subTitle: 'Publish Posts',
      title: 'Publishing Center',
      description: 'Manage drafts, schedule posts, and publish across platforms.',
      visual: <MultiSourceVisual />,
      path: '/posts',
      badge: null
    },
    {
      id: 'ai-auto-reply',
      subTitle: 'AI Smart Support',
      title: 'AUTO REPLY',
      description: 'Reply Settings / History / AI Templates',
      visual: <PerformanceVisual />,
      path: '/posts-and-comments',
      badge: null
    },
    {
      id: 'card-generator',
      subTitle: 'Card Generator',
      title: 'Carousel Cards',
      description: 'Transform text into beautiful carousel cards with multiple styles and themes.',
      visual: <StyleGeneratorVisual />,
      path: '/templates/content-generator',
      badge: 'HOT'
    },
    {
      id: 'ai-writing',
      subTitle: 'AI Writing',
      title: 'Text Post Generator',
      description: 'Start from ideas, trends, keywords, or random inspiration. AI helps you craft posts.',
      visual: <WritingModelVisual />,
      path: '/ai-writing',
      badge: null
    },
    {
      id: 'script-workflow',
      subTitle: 'Script Writing',
      title: 'Script Workflow',
      description: 'Reference creators, follow trends, AI helps you write video scripts.',
      visual: <VideoEditingVisual />,
      path: '/templates/creator-to-script',
      badge: null,
      comingSoon: true
    }
  ];

  const tools = [
    {
      id: 'fake-text',
      title: 'Fake Text Generator',
      icon: 'mdi:message-text',
      path: '/tools/fake-text-generator'
    },
    {
      id: 'fake-notification',
      title: 'Fake Notification',
      icon: 'mdi:bell-ring',
      path: '/tools/fake-notification-generator'
    },
    {
      id: 'fake-call',
      title: 'Fake Call Generator',
      icon: 'mdi:phone',
      path: '/tools/fake-call-generator'
    }
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: theme.bgPrimary,
      color: theme.textPrimary
    }}>
      <div style={{ display: 'flex', height: '100vh' }}>
        {/* Sidebar */}
        <Sidebar activePage="home" />

        {/* Main Content */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          background: '#FAFAFA'
        }}>
          <div className="max-w-6xl mx-auto py-12 px-6 lg:px-8">

            {/* Header */}
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 tracking-tight">
                Start Here
              </h1>
            </div>

            {/* Feature Grid - 3 Columns */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
              {features.map((feature) => (
                <FeatureCard
                  key={feature.id}
                  subTitle={feature.subTitle}
                  title={feature.title}
                  description={feature.description}
                  visual={feature.visual}
                  badge={feature.badge}
                  comingSoon={feature.comingSoon}
                  onClick={() => navigate(feature.path)}
                />
              ))}
            </div>

          </div>
        </div>

        {/* Right Sidebar - Calendar */}
        <UpcomingPostsCalendar />
      </div>
    </div>
  );
}

export default HomePage;
